import React, { useState, useContext, useEffect, useRef } from "react";
import "./styles/styles.css";
import "../../styles/global.css";
import { icons } from "../../constants";
import { useTheme } from "../../utils/ThemeContext";
import MultiSelectOptions from "./components/MultiSelectOptions";
import { TranslationsContext } from "../../utils/TranslationsContext";
import ExpandableText from "../TableThird/components/ExpandableText";

const TableHeader = ({
  options,
  totalWidth,
  seeAllColumns,
  setSeeAllColumns,
  hasMany,
  onSortChange,
  sortField,
  sortDirection,
  selectedStatusOptions,
  setSelectedStatusOptions,
  selectedSuggestionsOptions,
  setSelectedSuggestionsOptions,
  className,
  hideExpandToggle = false,
}) => {
  const { theme } = useTheme();
  const [showSelected, setShowSelected] = useState(false);
  const [showSelectedSuggestions, setShowSelectedSuggestions] = useState(false);
  const { t } = useContext(TranslationsContext);
  const ref = useRef(null);
  const refSuggestions = useRef(null);

  // Workflow order: submitted → in processing → rejected → approved.
  const statusOptions = [
    { key: "prijavljen", value: t("NEW") },
    { key: "u_obradi", value: t("IN_PROCESSING") },
    { key: "odbijen", value: t("REJECTED") },
    { key: "odobren", value: t("APPROVED") },
  ];

  const suggestionOptions = [
    { key: "odbijeniSvi", value: t("REJECTED_BY_ALL") },
    { key: "odobreniSvi", value: t("APPROVED_BY_ALL") },
    { key: "ostali", value: t("OTHERS") },
  ];

  const handleSortClick = (field) => {
    if (!field) return;
    if (!onSortChange) return;

    if (sortField === field) {
      onSortChange(field, sortDirection === "asc" ? "desc" : "asc");
    } else {
      onSortChange(field, "asc");
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setTimeout(() => setShowSelected(false), 0);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setTimeout(() => setShowSelected(false), 0);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickOutsideSuggestions = (e) => {
      if (
        refSuggestions.current &&
        !refSuggestions.current.contains(e.target)
      ) {
        setTimeout(() => setShowSelectedSuggestions(false), 0);
      }
    };
    document.addEventListener("mousedown", handleClickOutsideSuggestions);
    return () =>
      document.removeEventListener("mousedown", handleClickOutsideSuggestions);
  }, []);

  return (
    <div
      className={`flex-direction-column width-100 table-header ${
        seeAllColumns ? "show" : ""
      } ${hasMany ? "has-many" : ""}`}
    >
      {!hideExpandToggle && (
        <img
          src={
            theme === "light"
              ? !seeAllColumns
                ? icons.maximize
                : icons.minimize
              : !seeAllColumns
                ? icons.maximize_dark
                : icons.minimize_dark
          }
          width={24}
          height={24}
          className="show-all-columns"
          onClick={() => setSeeAllColumns(!seeAllColumns)}
          alt="see"
        />
      )}
      <div className="flex-direction-row width-100 table-header-content">
        {options
          ?.filter((opt) => opt.name?.toLowerCase() !== "children")
          .map((option, index) => {
            const isNonSortable = [
              "actions",
              "download",
              "slika_avatar",
              "predlozi",
              "actions_2",
              "actions_3",
              "status",
              "ip_opseg",
              "checkbox",
              "accreditation",
            ].includes(option.name?.toLowerCase());

            return (
              <div
                className={`flex-direction-row items-center gap-4 justify-between table-header-field ${
                  option.class?.toLowerCase() || ""
                } ${option.name?.toLowerCase() || ""} ${
                  seeAllColumns ? "" : "hide"
                } ${!isNonSortable ? "pointer" : ""} ${
                  className ? className : ""
                }`}
                key={index}
                style={{ width: `${(option.width / totalWidth) * 100}%` }}
                onClick={() => !isNonSortable && handleSortClick(option.name)}
              >
                {option.name?.toLowerCase() === "accreditation" ? (
                  <img
                    src={
                      theme === "light"
                        ? icons.accreditation
                        : icons.accreditation_dark
                    }
                    alt="accr"
                    width={28}
                    height={28}
                  />
                ) : option.name?.toLowerCase() === "drzavljanstvo" ? (
                  <img
                    src={
                      theme === "light" ? icons.country : icons.country_dark
                    }
                    alt="country"
                    width={20}
                    height={20}
                  />
                ) : option.name?.toLowerCase() === "status" ? (
                  <div className="relative width-100" ref={ref}>
                    <div
                      className="flex-direction-row width-100 justify-center items-center gap-4 pointer relative"
                      onClick={() => setShowSelected(!showSelected)}
                    >
                      {/* <p className="inria-sans-400 font-14">{t("STATUS")}</p> */}
                      <ExpandableText text={t("STATUS")} header />
                      <img
                        src={
                          theme === "light"
                            ? icons.arrow_down
                            : icons.arrow_down_dark
                        }
                        alt="img"
                        width={24}
                        height={24}
                        style={{
                          transform: showSelected
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                          transition: "transform 0.15s ease",
                        }}
                      />
                    </div>
                    {showSelected && (
                      <MultiSelectOptions
                        selectedOptions={selectedStatusOptions}
                        setSelectedOptions={setSelectedStatusOptions}
                        t={t}
                        options={statusOptions}
                        soloWhenAllSelected
                      />
                    )}
                  </div>
                ) : option.name === "download" ? (
                  <img
                    src={
                      theme === "light" ? icons.download : icons.download_dark
                    }
                    alt="down"
                  />
                ) : option.name?.toLowerCase() === "predlozi" ? (
                  <div className="relative width-100" ref={refSuggestions}>
                    <div
                      className="flex-direction-row width-100 justify-center items-center gap-4 pointer relative"
                      onClick={() =>
                        setShowSelectedSuggestions(!showSelectedSuggestions)
                      }
                    >
                      <ExpandableText
                        text={t("SUGGESTION")}
                        header
                        className="predlozi"
                      />

                      <img
                        src={
                          theme === "light"
                            ? icons.arrow_down
                            : icons.arrow_down_dark
                        }
                        alt="img"
                        width={24}
                        height={24}
                        style={{
                          transform: showSelectedSuggestions
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                          transition: "transform 0.15s ease",
                        }}
                      />
                    </div>
                    {showSelectedSuggestions && (
                      <MultiSelectOptions
                        selectedOptions={selectedSuggestionsOptions}
                        setSelectedOptions={setSelectedSuggestionsOptions}
                        t={t}
                        options={suggestionOptions}
                      />
                    )}
                  </div>
                ) : (
                  <>
                    <p className="inria-sans-400 font-14">{option.title}</p>
                    {!isNonSortable && sortField === option.name && (
                      <img
                        src={
                          sortDirection === "asc"
                            ? theme === "light"
                              ? icons.arrow_sort_down
                              : icons.arrow_sort_down_dark
                            : theme == "light"
                              ? icons.arrow_sort_up
                              : icons.arrow_sort_up_dark
                        }
                        alt="icon"
                        width={16}
                        height={16}
                      />
                    )}
                  </>
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default TableHeader;
